import { Layout } from 'antd';
import { lazy, Suspense } from 'react';
import SideMenu from 'apps/home/components/SideMenu';
import useApps from 'hooks/use-app';
import { Outlet } from 'react-router-dom';
import Footer from './Footer';
import Header from './Header';
import { getItems } from './SideMenu/config';

// The agent app lists chat threads in the sidebar; loaded only there.
const AgentThreadSidebar = lazy(() =>
  import('apps/agent/components/ThreadSidebar')
);

const AppLayout = () => {
  const { appKey } = useApps();
  const items = getItems(appKey);

  return (
    <Layout>
      <SideMenu
        items={items}
        extra={
          appKey === 'agent' ? (
            <Suspense fallback={null}>
              <AgentThreadSidebar />
            </Suspense>
          ) : null
        }
      />
      <Layout>
        <Header />
        <Layout.Content>
          <div
            className="site-layout-background md:p-4 md:mx-4 px-1 rounded font-sans"
            style={{ minHeight: 360 }}
          >
            <Outlet />
          </div>
        </Layout.Content>
        <Footer />
      </Layout>
    </Layout>
  );
};

export default AppLayout;
